import { render, staticRenderFns } from "./ImobilizadoUltimoMesTipologiaPie.vue?vue&type=template&id=4e2c2d02&"
import script from "./ImobilizadoUltimoMesTipologiaPie.vue?vue&type=script&lang=js&"
export * from "./ImobilizadoUltimoMesTipologiaPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports